module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/march-ee772c39a4ffbb1d90b2ef2be915ed49.png";